jQuery(document).ready(function($) {

  console.log('referrer is on');

  let $targets = $('.append-page-id-to-href');

  $targets.each(function() {
    let $target = $(this);

    let $appendTo = $target.find('a');

    if (!$appendTo.length) return;

    const prevHref = $appendTo.attr('href');
    const postId = window.KP_WP_POST_ID;
    const postSlug = window.location.pathname.match(/[^\/]+/g);

    if (!postId || !prevHref) return;

    const prevHrefAsUrl = new window.URL(prevHref);

    const referrerId = `${postId}-${postSlug}`;

    let newHref = prevHref;
    if (!prevHrefAsUrl.search)
      newHref += "?referrer_id=" + referrerId;
    else
      newHref += "&referrer_id=" + referrerId;

    $appendTo.attr('href', newHref);
  });
});
